import { deletePortalCard } from '@api/v4/private/portal_cards';

const submitCardDelete = ((
  portalCardId: string,
  closeModal: () => void,
  triggerCardsRefresh: () => void
): void => {
  deletePortalCard(portalCardId)
    .then(() => {
      triggerCardsRefresh();
      closeModal();
    })
    .catch(() => {
      Notify.create({
        title: bfTranslate("Something went wrong!"),
        body: bfTranslate("Please try deleting again."),
        type: "error"
      });
      closeModal();
    });
});

export const handleDeletion = (
  portalCardId: string,
  name: string,
  closeModal: () => void,
  triggerCardsRefresh: () => void
): void => {
  const swalOptions = {
    title: `${bfTranslate("Are you sure you want to delete")} ${name}?`,
    text: bfTranslate("This action can not be undone."),
    type: "warning",
    showCancelButton: true,
    cancelButtonText: bfTranslate("Cancel"),
    confirmButtonText: bfTranslate("Delete"),
    closeOnConfirm: true,
  };
  window.swal(swalOptions, (confirmSelected) => {
    if (confirmSelected) {
      submitCardDelete(portalCardId, closeModal, triggerCardsRefresh);
    } else {
      closeModal();
    }
  });
};
